import React from 'react'
import arrayMutators from 'final-form-arrays'
import { Field, Form } from 'react-final-form'
import FormTextField from '../../../../../components/fields/FormTextField'
import { FormattedMessage } from 'react-intl'
import Button from '../../../../../components/button/Button'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../../../../styles'
import { FinancialPrelevementInfoModel } from '../../../profileModel'
import FormFile from '../../../../../components/fields/FormFile'
import { FieldArray } from 'react-final-form-arrays'
import Loader from '../../../../../components/loader/Loader'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            formStyle: {
                marginBottom: 20
            },
            inputStyle: {
                marginBottom: 20
            },
            buttonContainerStyle: {
                marginTop: 50
            },
            spinnerStyle: {
                textAlign: 'center'
            }
        }
    )
)

interface AcceptingProps {
    onSubmit: (values: FinancialPrelevementInfoModel) => void,
    validate: (values: FinancialPrelevementInfoModel) => any,
    loading: boolean
}

type PrelevementFinancialInfoFormProps = AcceptingProps

const PrelevementFinancialInfoForm: React.FC<PrelevementFinancialInfoFormProps> = (
    {
        onSubmit,
        validate,
        loading
    }
) => {
    const classes = useStyle()

    const buttonContainerClass: ClassValue = classNames(
        'col-xs-12',
        classes.buttonContainerStyle
    )

    return (
        <Form
            mutators={{
                ...arrayMutators
            }}
            onSubmit={onSubmit}
            validate={validate}
            render={
                (
                    {
                        handleSubmit
                    }
                ) => (
                    <form
                        onSubmit={handleSubmit}
                        className={classNames('row', classes.formStyle)}
                    >
                        <div className={classNames('col-xs-12', classes.inputStyle)}>
                            <Field
                                name="iban"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step2.iban',
                                    defaultMessage: 'Code IBAN',
                                    description: 'IBAN placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-12', classes.inputStyle)}>
                            <Field
                                name="bic"
                                component={FormTextField}
                                placeholder={{
                                    id: 'profile.prelevement.step2.bic',
                                    defaultMessage: 'Code BIC',
                                    description: 'BIC placeholder'
                                }}
                            />
                        </div>
                        <div className={classNames('col-xs-12', classes.inputStyle)}>
                            <FieldArray
                                name="rib"
                                render={
                                    ({ fields, meta }) => (
                                        <FormFile
                                            fields={fields}
                                            meta={meta}
                                            label={
                                                <FormattedMessage
                                                    id="profile.prelevement.step2.rib"
                                                    defaultMessage="Ajouter votre RIB"
                                                    description="Rib input"
                                                />
                                            }
                                            multiple={false}
                                            id="rib"
                                        />
                                    )
                                }
                            />
                        </div>

                        <div className={buttonContainerClass}>
                            <div className="col-xs-12 col-md-4">
                                {loading ? (
                                    <div className={classes.spinnerStyle}>
                                        <Loader />
                                    </div>
                                ) : (<Button
                                        background="backgroundAccessibility"
                                        color="colorWhite"
                                        textStyle="text8"
                                        type="submit"
                                        size="bigButton"
                                    >
                                        <FormattedMessage
                                            id="global.btn.validate"
                                            defaultMessage="Valider"
                                            description="Validate button"
                                        />
                                    </Button>
                                )}

                            </div>
                        </div>
                    </form>
                )
            }
        />
    )
}

export default PrelevementFinancialInfoForm
